import BotIntelligence from './themes/BotIntelligenceLight.css';
import BotBanner from './components/BotBanner/themes/BotBannerLight.css';
import DisplayOptions from './components/DisplayOptions/themes/DisplayOptionsLight.css';
import AutomationScoreSlider
  from './components/DisplayOptions/components/AutomationScoreSlider/themes/AutomationScoreSliderLight.css';
import TopClustersByVolume from './components/TopClustersByVolume/themes/TopClustersByVolumeLight.css';
import CategoryGraph from './components/CategoryGraph/themes/CategoryGraphLight.css';
import CategoryGraphSection
  from './components/CategoryGraph/components/CategoryGraphSection/themes/CategoryGraphSectionLight.css';
import MenuBulkActions from './components/MenuBulkActions/themes/MenuBulkActionsLight.css';
import Tooltip from './components/Tooltip/themes/TooltipLight.css';
import SmartFilterSummary from './components/SmartFilterSummary/themes/SmartFilterSummaryLight.css';
import ClusterGraph from './components/ClusterGraph/themes/ClusterGraphLight.css';
import GraphLegend from './components/GraphLegend/themes/GraphLegendLight.css';
import SearchFilters from './containers/SearchFilters/themes/SearchFiltersLight.css';
import GraphContainer from './containers/GraphContainer/themes/GraphContainerLight.css';
import ActionsMenuPanel from './containers/ActionsMenuPanel/themes/ActionsMenuPanelLight.css';
import AddToGroupModal from './containers/AddToGroupModal/themes/AddToGroupModalLight.css';
import GraphDataExport from './containers/GraphDataExport/themes/GraphDataExportLight.css';

export default {
  BotIntelligence,
  BotBanner,
  SearchFilters,
  DisplayOptions,
  AutomationScoreSlider,
  TopClustersByVolume,
  GraphContainer,
  ActionsMenuPanel,
  CategoryGraph,
  CategoryGraphSection,
  ClusterGraph,
  GraphLegend,
  AddToGroupModal,
  MenuBulkActions,
  Tooltip,
  SmartFilterSummary,
  GraphDataExport
};
